<template>
  <v-row>
    <v-col class="pb-0 pt-0" cols="12" md="6" lg="3">
      <el-date-picker
        required
        pastDates
        :disabled="onlyView"
        label="Dokumento, patvirtinančio prokūros pasibaigimą, data"
        v-model="formData.basis_date"
      />
    </v-col>
    <v-col class="pb-0 -0 pt-0" cols="12" md="6" lg="3">
      <el-autocomplete
        required
        :disabled="onlyView"
        :items="classifiers['expiration-reason']"
        itemvalue="value"
        itemtext="text"
        label="Prokūra pasibaigė"
        v-model="formData.expiration_reason_id"
      />
    </v-col>
    <v-col class="pb-0 -0 pt-0" cols="12" md="6">
      <el-textarea
        :disabled="onlyView"
        :maxlength="2000"
        label="Pasibaigimo aprašymas"
        v-model="formData.expiration_reason_description"
      />
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'DeregistrationData',
  components: {},
  props: {
    formData: [Array, Object],
    onlyView: Boolean
  },
  data() {
    return {
      classifiers: {},
    }
  },
  computed: {
    formatedHasEndedSelect() {
      return { lt: [], en: [] }
    },
  },
  created() {
     this.getClassifiers()
  },
  methods: {
    // expiration-reasons
    getClassifiers() {
      this.loadDefault = true
       let requiredClassifiers = { classifiers: ['expiration-reason'] }
      this.$axios
        .post(`classifiers`, requiredClassifiers)
        .then((res) => {
          this.classifiers = res.data.classifiers
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.loadDefault = false
        })
    },
  },
}
</script>

<style>
</style>
